import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PUBLIC_ROUTES = ['/login'];
const AuthWatcher = () => {
//   const token = useSelector((state) => state?.auth?.token);
const token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    if (!token && !PUBLIC_ROUTES.includes(location.pathname)) {
      navigate('/login');
    }
  }, [token, navigate, location.pathname]);

  return null;
};

export default AuthWatcher;